import { Container, Row, Col, Alert, Button } from 'react-bootstrap';
import React, { FunctionComponent, useEffect, useLayoutEffect } from 'react';
import '../../../assets/css/baseLayout.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import HeaderMenu from './HeaderMenu';
import ApiSideBar from './ApiSideBar';
import Footer from '../FooterLayout/FooterMenu';
import Drawer from '../../../components/DashboardComponents/Drawer';
import CookieMessage from '../../Modals/CookieMessage';
import { useState } from 'react';
import ReactGA from 'react-ga4';
import Terminal from 'terminal-in-react';
import SessionService from '../../../services/SessionsService';
import FooterMenu from '../DashboardLayout/FooterMenuAccess';
import favicon from '../../../assets/img/logos/icono_DS.svg';
import DocsRightSidebar from '../../DocsRightSidebar/DocsRightSidebar';
import { useHistory } from 'react-router-dom';
import { saveScrollPosition } from './docsScrollRestore';

// Rutas que pinta BaseLayout (las de appRoutes.tsx con ContentDoc / ContentWiki).
// La misma lista está en index.html.ejs para el fondo oscuro mientras carga
const DOCS_PATHS = /^\/(wiki|docs|default|developer|faq|apis|downloads)(\/|$)/i;

//form
import CreatAppForm from './forms/CreateApp'

// import HeaderMenu from '../baseLayout/HeaderMenu';
import DashboardSideBar from '../../functionalComponents/DashboardLayout/DashboardSidebar';

//import pseudoFileSystem from 'terminal-in-react-pseudo-file-system-plugin';
//const FileSystemPlugin = pseudoFileSystem(); 
//import NodeEvalPlugin from 'terminal-in-react-node-eval-plugin';

type BaseProps = {
  sider: any,
  active?: string,
  children: any
};




const BaseLayout: FunctionComponent<BaseProps> = ({ sider, active, children }: BaseProps) => {


  const [isDrawerOpen, setIsDrawerOpen] = useState(false);
  const [activeSidebar, setActiveSidebar] = useState('api-products');
  const [thankyou, setThankyou] = useState(false);
  const [goodFeedback, setGood] = useState(true);
  const [badFeedback, setBad] = useState(true);
  const [StyleGood, setStyleGood] = useState({ backgroundColor: '#818881' });
  const [StyleBad, setStyleBad] = useState({ backgroundColor: '#818881' });
  const [hooverGood, sethooverGood] = useState(false);
  const [hooverBad, sethooverBad] = useState(false);
  const [panel, setPanel] = useState(false);


  const [isDarkMode, setIsDarkMode] = useState(false); 

  // useLayoutEffect (no useEffect): al cambiar entre páginas de docs (/docs <-> /wiki)
  // la clase se quita al desmontar la anterior y se vuelve a poner antes de pintar
  // la nueva; con useEffect se pintaba un instante sin el tema y se veía en blanco
  useLayoutEffect(() => {
    document.body.classList.remove("dark-mode");
    document.body.classList.add('devportal-dashboard');
    // index.html.ejs pone el fondo oscuro en <html> mientras carga el JavaScript;
    // con la clase ya puesta el fondo lo da el body
    document.documentElement.style.backgroundColor = '';
    if (isDarkMode) {
      //document.body.classList.add("dark-mode");
    } else {
      //document.body.classList.remove("dark-mode");
    }
    
    // Disparar un evento personalizado para notificar a otros componentes sobre el cambio de tema
    const themeChangedEvent = new Event('themeChanged');
    window.dispatchEvent(themeChangedEvent);

    // Al salir de las páginas de docs se quita la clase, para que el tema de docs
    // (_docsCursor.scss) no se quede aplicado en otras vistas de la SPA.
    // Se quita en un microtask y solo si ya no queda una cabecera de docs: al pasar
    // de una página de docs a otra (/docs <-> /wiki, /default -> /wiki...) este
    // BaseLayout se desmonta y el nuevo se monta en el mismo commit, y si la clase
    // se quitaba aquí la cabecera y el sidebar nuevos arrancaban con el tema claro
    // y animaban a oscuro (transition de 0.3s): el pantallazo blanco
    return () => {
      Promise.resolve().then(() => {
        if (!document.querySelector('.dp-navbar--docs')) {
          document.body.classList.remove('devportal-dashboard');
        }
      });
    };
  }, [isDarkMode]);

  // Posición de scroll de cada URL, para volver a ella al recargar (docsScrollRestore)
  useEffect(() => {
    let frame = 0;
    const onScroll = () => {
      if (frame) return;
      frame = requestAnimationFrame(() => { frame = 0; saveScrollPosition(); });
    };
    window.addEventListener('scroll', onScroll);
    window.addEventListener('pagehide', saveScrollPosition);
    return () => {
      cancelAnimationFrame(frame);
      window.removeEventListener('scroll', onScroll);
      window.removeEventListener('pagehide', saveScrollPosition);
    };
  }, []);

  // Enlaces dentro del contenido que recargaban la página entera (con el
  // pantallazo blanco mientras carga): los que tienen href vacío (algunos .md)
  // no hacen nada, y los que van a otra página de la documentación navegan sin recargar
  const history = useHistory();
  useEffect(() => {
    const onClick = (e: MouseEvent) => {
      const link = (e.target as Element).closest && (e.target as Element).closest('.dp-scrollContainer a[href]') as HTMLAnchorElement | null;
      if (!link || link.closest('.docs-right-sidebar')) return;
      if (link.getAttribute('href') === '') {
        e.preventDefault();
        return;
      }
      if (e.defaultPrevented || e.button !== 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey || link.target === '_blank') return;
      const url = new URL(link.href);
      if (url.origin === window.location.origin && DOCS_PATHS.test(url.pathname)) {
        e.preventDefault();
        history.push(url.pathname + url.search + url.hash);
      }
    };
    document.addEventListener('click', onClick);
    return () => document.removeEventListener('click', onClick);
  }, []);

  const toggleDarkMode = () => {
    console.log("===== TOGGLE DARK MODE =====");
    console.log("Estado actual del tema:", isDarkMode ? "Oscuro" : "Claro");
    
    const newTheme = false //!isDarkMode;
    console.log("Cambiando al tema:", newTheme ? "Oscuro" : "Claro");
    
    setIsDarkMode(newTheme);
    localStorage.setItem("theme", "light");
    
    // Disparar un evento personalizado para notificar a otros componentes sobre el cambio de tema
    const themeChangedEvent = new Event('themeChanged');
    window.dispatchEvent(themeChangedEvent);
    
    console.log("Tema guardado en localStorage:", "light");
    console.log("Evento themeChanged disparado");
    console.log("============================");
  };

  // Escuchar cambios de tema para aplicarlos al sidebar móvil
  useEffect(() => {
    const handleThemeChange = () => {
      // Este evento se dispara cuando cambia el tema
      // El sidebar móvil tomará los colores de las variables CSS
      console.log("Tema cambiado detectado en BaseLayout");
    };

    window.addEventListener('themeChanged', handleThemeChange);
    return () => {
      window.removeEventListener('themeChanged', handleThemeChange);
    };
  }, []);
  
  useEffect(() => {
    // favicon
    const link = document.createElement('link');
    link.rel = 'icon';
    link.href = favicon; // Usa la ruta importada directamente
    document.head.appendChild(link);

    // favicon
    return () => {
        document.head.removeChild(link);
    };
}, []);


  ////test Data
  const apiProduct2s = [
    {
      id: 'api1',
      titleNav: 'User Management API',
      version: '1.0',
      description: 'API for managing user accounts and authentication.',
      swagger_link: 'https://api.example.com/swagger/user-management',
      documentation_links: [
        { title: 'Getting Started Guide', url: 'https://docs.example.com/user-management/getting-started' },
        { title: 'API Reference', url: 'https://docs.example.com/user-management/api-reference' }
      ],
      basePath: '/user-management', // Añadido
      icon: 'users' // Añadido
    },
    {
      id: 'api2',
      titleNav: 'Order Management API',
      version: '2.1',
      description: 'API for handling orders, payments, and tracking.',
      swagger_link: 'https://api.example.com/swagger/order-management',
      documentation_links: [
        { title: 'Order Processing Guide', url: 'https://docs.example.com/order-management/processing' },
        { title: 'API Reference', url: 'https://docs.example.com/order-management/api-reference' }
      ],
      basePath: '/order-management', // Añadido
      icon: 'orders' // Añadido
    }
  ];

  const apiData = {
    menus: [
      {
        id: 'api1',
        title: "User Management API",
        icon: "dashboard",
        version: '1.0',
        description: 'API for managing user accounts and authentication.',
        swagger_link: 'https://api.example.com/swagger/user-management',
        basePath: '/user-management',
        links: [
          {
            title: 'Getting Started Guide',
            url: 'https://docs.example.com/user-management/getting-started'
          },
          {
            title: 'API Reference',
            url: 'https://docs.example.com/user-management/api-reference'
          }
        ]
      },
      {
        id: 'api2',
        title: "Order Management API",
        icon: "orders",
        version: '2.1',
        description: 'API for handling orders, payments, and tracking.',
        swagger_link: 'https://api.example.com/swagger/order-management',
        basePath: '/order-management',
        links: [
          {
            title: 'Order Processing Guide',
            url: 'https://docs.example.com/order-management/processing'
          },
          {
            title: 'API Reference',
            url: 'https://docs.example.com/order-management/api-reference'
          }
        ]
      }
    ]
  };

  const toggleDrawer = () => {
    setIsDrawerOpen(!isDrawerOpen);
  };

  useEffect(() =>{ 
    ReactGA.send({ 
      hitType: 'pageview', 
      page: window.location.pathname, 
      title: 'Developer Portal' });
   }, [])


  const BadFeedback = () => {
    setGood(false);
    setThankyou(true);
    setBad(false);
    ReactGA.event({
      category: 'Feedback',
      action: 'Bad',
      label: (window.location.pathname + window.location.search)
    });

  }
  
  const GoodFeedback = () => {
    setBad(false);
    setThankyou(true);
    setGood(false);
    ReactGA.event({
      category: 'Feedback',
      action: 'Good',
      label: (window.location.pathname + window.location.search)
    });
  }

  const toggleHooverGood = () => {
    if (goodFeedback && badFeedback) {
      if (hooverGood) { setStyleGood({ backgroundColor: '#818881' }); sethooverGood(false); }
      else { setStyleGood({ backgroundColor: '#3e413e' }); sethooverGood(true); }
    }
  }
  const toggleHooverBad = () => {
    if (goodFeedback && badFeedback) {
      if (hooverBad) { setStyleBad({ backgroundColor: '#818881' }); sethooverBad(false); }
      else { setStyleBad({ backgroundColor: '#3e413e' }); sethooverBad(true); }
    }
  }


  const togglePanel = () => {
    setPanel(!panel);
  }
  const cambio = () => {

    setBad(true);
    setGood(true);
    setThankyou(false);
    setStyleGood({ backgroundColor: '#818881' });
    setStyleBad({ backgroundColor: '#818881' });
    sethooverGood(false);
    sethooverBad(false);

  }

  if (SessionService.eventEmitter) {
    SessionService.eventEmitter.once('panel', function () {
      console.log('Paneling');
      if (!SessionService.SCREAMING) {
        SessionService.SCREAMING = true;

        if (panel) {

          const elem1 = document.getElementById('pannel') as HTMLDivElement;
          elem1.hidden = true;
          const elem2 = document.getElementById('principal') as HTMLDivElement;
          elem2.style.height = '100%'
        } else {

          const elem1 = document.getElementById('pannel') as HTMLDivElement;
          elem1.hidden = false;
          const elem2 = document.getElementById('principal') as HTMLDivElement;
          elem2.style.height = '80%'
        }

        togglePanel();
        SessionService.SCREAMING = false;
      }
    });
  }

  return (
    <>
      <div id='dashboardWrapper' className='dp-dashboard-wrapper'>
     {/*}   <div className="theme-toggle-container">
          <button onClick={toggleDarkMode} className="toggle-dark-mode">
            <span>{isDarkMode ? "Dark Mode" : "Light Mode"}</span>
          </button>
        </div> */}
        <HeaderMenu isDocs />
        <div id="page-content-wrapper" className='w-100'>
          <ApiSideBar sider={sider} active={active} />
          <div id="content" className="container-fluid mt-0 p-0">
            <div className="dp-scrollContainer">
              {/* Columna de contenido + columna derecha (feedback, AI tools, On this page) */}
              <div className="docs-page">
                <div className="docs-page__main">
                  {children}
                </div>
                <DocsRightSidebar />
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  )
}

export default BaseLayout;